/**
 * M64 Reveal Marquee Section
 * Handles auto-scrolling image carousel that swaps based on selected color
 */

const M64Marquee = {
  elements: {
    sets: null
  },
  
  init() {
    this.elements.sets = document.querySelectorAll('.m64-marquee__set');
    this.bindEvents();
  },
  
  bindEvents() {
    document.addEventListener('m64ColorSelected', (e) => {
      this.setActiveColor(e.detail.color);
    });
  },
  
  setActiveColor(color) {
    this.elements.sets.forEach(set => {
      const isActive = set.dataset.color === color;
      set.classList.toggle('is-active', isActive);
    });
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => M64Marquee.init());
} else {
  M64Marquee.init();
}

// Expose for debugging
window.M64Marquee = M64Marquee;